import { render, staticRenderFns } from "./DocumentDetailsEditor.vue?vue&type=template&id=450f37fc&scoped=true&"
import script from "./DocumentDetailsEditor.vue?vue&type=script&lang=js&"
export * from "./DocumentDetailsEditor.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDetailsEditor.vue?vue&type=style&index=0&id=450f37fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450f37fc",
  null
  
)

export default component.exports